import Decimal from 'decimal.js'

export const buyerIdSearchParams = (buyerId: string): number => {
	try {
		if (buyerId.trim().length > 0) {
			const value = decodeURIComponent(buyerId.trim())
			const v = new Decimal(value)
			return v.toNumber()
		}
		return 0
	} catch (error) {
		console.error({ error })
		return 0
	}
}